<template>
  <v-dialog
    id="modal-demo"
    ref="modal"
    v-model="open"
    width="500"
    :fullscreen="$vuetify.breakpoint.xsOnly"
  >
    <v-card class="text-center">
      <v-card-text class="body-1 pa-9">
        <div
          v-if="isCompleteFailure"
          id="full-order-failure-content"
        >
          <div
            id="header"
            class="h5"
          >
            <div>{{ $t('order-failure-full-header') }}</div>
          </div>
          <div id="description">
            <div>{{ $t('order-failure-full-description') }}</div>
          </div>
        </div>
        <div
          v-if="isPartialFailure"
          id="partial-order-failure-content"
        >
          <div
            id="header"
            class="h5"
          >
            <div>{{ $t('order-failure-partial-header') }}</div>
          </div>
          <div id="description-text">
            <span>{{ $t('order-failure-partial-description') }}</span>
          </div>
          <div
            id="failed-items"
            class="body-2 my-6 px-6"
          >
            <v-row
              v-for="(item, index) in failedItems"
              :key="index"
              class="failed-item-display"
            >
              <v-col
                cols="6"
                class="text-right font-weight-bold"
              >
                {{ item.rewardName }}
              </v-col>
              <v-col
                cols="6"
                class="text-left"
              >
                {{
                  $money(
                    item.lineItemTotal.value,
                    item.lineItemTotal.currencyCode
                  )
                }}
              </v-col>
            </v-row>
          </div>
          <div id="credit-text">
            {{ $t('order-failure-partial-credit') }}
          </div>
        </div>
      </v-card-text>

      <v-card-actions class="justify-center pb-9">
        <v-btn
          id="ok-button"
          color="accent"
          large
          min-width="200"
          @click="hideCallback"
        >
          {{ $t('global-button-ok') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ErrorModal',
  props: {
    open: {
      type: Boolean,
      required: true
    },
    failureType: {
      type: String,
      required: true
    },
    failedItems: {
      type: Array,
      required: false,
      default: () => []
    }
  },
  computed: {
    isCompleteFailure () {
      return this.failureType === 'COMPLETE'
    },
    isPartialFailure () {
      return this.failureType === 'PARTIAL'
    }
  },
  methods: {
    hideCallback () {
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../scss/variables';
.h5 {
  font-weight: bold;
  color: map-get($shades, 'black');
}
.failed-item-display {
  border-bottom: solid 1px map-get($grey, 'lighten-2');
}
</style>
